const ns = "MODULES_VIEWS";
export const REQUEST = `${ns}_REQUEST`;
export const RECEIVE = `${ns}_RECEIVE`;
export const SET_ACTIVE = `${ns}_SET_ACTIVE`;
export const UPDATE = `${ns}_UPDATE`;
